export const warranty_documents = [
    {
        title: 'Standard Product Limited Warranty',
        slug: 'standard',
        documents: [
            {
                href: 'http://www.owenscorning.com/dms/10023873',
                lang: 'English',
                size: 'PDF | 1.3mb',
            },
        ],
    },
    {
        title: 'System Protection Roofing Limited Warranty',
        slug: 'system-protection',
        documents: [
            {
                href: 'http://www.owenscorning.com/dms/10020610',
                lang: 'English',
                size: 'PDF | 2mb',
            },
        ],
    },
    {
        title: 'Preferred Protection Roofing System Limited Warranty',
        slug: 'preferred-protection',
        documents: [
            {
                href: 'http://www.owenscorning.com/dms/10020609',
                lang: 'English',
                size: 'PDF | 2mb',
            },
        ],
    },
    {
        title: 'Platinum Protection Roofing System Limited Warranty',
        slug: 'platinum-protection',
        documents: [
            {
                href: 'http://www.owenscorning.com/dms/10020608',
                lang: 'English',
                size: 'PDF | 2mb',
            },
        ],
    },
    {
        title: 'International Warranty on non-U.S. and Canada',
        slug: 'international',
        documents: [
            {
                href: 'http://www.owenscorning.com/dms/24762',
                lang: 'English',
                size: 'PDF | 1.9mb',
            },
        ],
    },
];